import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable()
export class DispersaoUrgenciaEmergenciaService {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  getDataGoApi(regans: string, ano_base: number) {
    return this.simuladorGoApi
      .fetchDispersaoUrgenciaEmergencia({
        regans,
        ano_base,
      })
      .pipe(map(data => data.items));
  }

  getCompetenciaRpsGoApi(regans: string) {
    return this.simuladorGoApi.fetchCompetenciaRps({ regans }).pipe(map(data => data.items[0]));
  }

  getMaxAnoBase(regans: string): Observable<number> {
    return this.simuladorGoApi.fetchDispersaoUrgenciaEmergenciaMaxAnoBase({ regans }).pipe(map(data => data.items[0]?.ano_base));
  }
}
